export default {
  Sending_succeeded: 'Terkirim berhasil',
  old_password_no: 'Kata sandi lama tidak boleh kosong.',
  New_password_no: 'Kata sandi baru tidak boleh kosong dan harus terdiri dari 6-16 karakter berupa angka dan huruf!',
  Confirm_new_password: 'Pastikan kata sandi baru Anda tidak kosong dan terdiri dari 6-16 karakter angka dan huruf!',
  re_enter: 'Kedua input tidak sama, silakan diulang kembali',
  no_identical: 'Kata sandi baru dan kata sandi asli harus berbeda.',
  up_password_success: 'Kata sandi berhasil diubah.',
  Old_password_error: 'Kata sandi lama salah.',
  modify_successfully: 'Modifikasi berhasil',
  up_Phone: 'Nomor telepon berhasil diubah.',
  modify_phone: 'Ubah nomor ponsel',
  dialog_tips: 'Apakah Anda yakin ingin mengganti nomor telepon Anda? Jika ya, nomor telepon lama Anda akan diverifikasi terlebih dahulu. Nomor telepon baru Anda akan diverifikasi setelah itu.',
  old_phone_code: 'Masukkan kode verifikasi nomor ponsel lama Anda',
  Modify_contact_name: 'Ubah nama kontak',
  Modify_agent_name: 'Nama Agen Perubahan',
  Modify_renewal_fs: 'Ubah informasi kontak perpanjangan',
  Modify_detailed_address: 'Ubah alamat detail',
  org_name: 'Ubah nama unit',
  verifying_phone: 'Memverifikasi nomor telepon baru...',
  verifying_phone_tow: 'Memverifikasi nomor telepon lama...',
  code_success: 'Kode verifikasi berhasil dikirim',
  import_phone: 'Masukkan kode verifikasi nomor ponsel baru',
  Sending_verification_code: 'Mengirim kode verifikasi...',
  old_password_yes: 'Verifikasi nomor telepon lama berhasil.',
  New_mobile_number: 'Nomor ponsel baru',
  Entera_new_phone: 'Masukkan nomor ponsel baru',
  Renewal_contact_information: 'Informasi Kontak Perpanjangan',
  Account_security: 'Untuk memastikan keamanan akun Anda, harap lengkapi informasi pribadi Anda terlebih dahulu.',
  take_back: 'Kembali',
  Reset_succeeded: 'Reset berhasil',
  row_passwords: 'Kedua kata sandi tidak cocok.',
  user_password_no: 'Nama pengguna atau kata sandi tidak boleh kosong.',
  //共用
  Loggingin: 'Sedang masuk...',
  country: 'Silakan pilih wilayah',
  country1: 'Pilih wilayah',
  loading: 'memuat...',
  create_successfully: 'Pembuatan berhasil!',
  Pleaseselectanagentfirst: 'Silakan pilih agen terlebih dahulu.',
  Theminimumsalesquantitysonepiece: 'Jumlah penjualan minimum adalah satu lembar.',
  Pleaseselectservicecardtype: 'Silakan pilih jenis kartu layanan.',
  Insufficientvoicecardbalance: 'Saldo kartu suara tidak mencukupi',
  Recordingcardbalanceisinsufficient: 'Saldo kartu perekaman tidak mencukupi',
  Insufficientbalanceoflocationcard: 'Saldo kartu posisi tidak mencukupi',
  InsufficientSOScardbalance: 'Saldo kartu SOS tidak mencukupi',
  Fencecardbalanceisinsufficient: 'Saldo kartu pagar tidak mencukupi',
  Insufficientvideocardbalance: 'Saldo kartu grafis tidak mencukupi',
  Theduplexcardbalanceisinsufficient: 'Saldo tidak mencukupi pada kartu ganda',
  Insufficientbalanceonvipcard: 'Saldo kartu VIP tidak mencukupi',
  Confirmsalesinformation: 'Konfirmasikan informasi penjualan',
  servicecardpasswordmistake: 'Format kata sandi kartu layanan yang dimasukkan salah.',
  Servicecardpasswordinputerror: 'Kata sandi kartu layanan salah',
  successfulsales: 'Penjualan berhasil',
  Pleaseselecttheunitfirst: 'Silakan pilih unit Anda terlebih dahulu.',
  Yourinputisemptypleasereenter: 'Input Anda kosong. Silakan masukkan kembali!',
  Theenteredimeinumberisempty: 'Nomor IMEI yang Anda masukkan salah. Silakan masukkan kembali!',
  Donotaddrepeatedly: 'Mohon tidak duplikat!',
  TheQRcodeiswrong: 'Kode QR salah',
  TheIMEInumberiswrong: 'Nomor IMEI yang Anda pindai salah. Silakan pindai lagi!',
  Donotscanthecoderepeatedly: 'Mohon jangan memindai kode QR berulang kali.',
  Pleaseselectausertype: 'Silakan pilih jenis pengguna!',
  Pleaseselectaunit: 'Silakan pilih unit',
  Userprefixnicknamecannotbeempty: 'Awalan nama panggilan pengguna tidak boleh kosong!',
  nicknameNoXhx: 'Awalan dan nama panggilan pengguna terdiri dari 2-26 karakter.',
  PleaseaddIMEInumber: 'Mohon tambahkan nomor IMEI!',
  YoucanadduptoIMEIsbyscanningthecode: 'Anda dapat menambahkan hingga 100 IMEI dengan memindai kode QR!',
  YouhaverepeatedlyaddedIMEIpleasedeleteit: 'Harap hapus semua IMEI duplikat yang telah Anda tambahkan!',
  Yourvoicecardisinsufficient: 'Saldo kartu suara Anda hampir habis, silakan isi ulang terlebih dahulu!',
  Yourrecordingcardisinsufficient: 'Saldo kartu rekaman Anda hampir habis. Mohon isi ulang terlebih dahulu!',
  Yourlocationcardisinsufficient: 'Kartu lokasi Anda memiliki saldo rendah. Harap isi ulang kartu Anda terlebih dahulu!',
  YourSOScardisinsufficient: 'Saldo kartu SOS Anda hampir habis. Mohon isi ulang!',
  Yourfencecardisinsufficient: 'Jumlah kartu pagar Anda sedikit, harap isi ulang akun Anda!',
  Yourvideocardisinsufficient: 'Kartu video Anda memiliki saldo rendah, harap isi ulang kartu Anda!',
  Yourduplexcardisnotenough: 'Saldo kartu dupleks Anda rendah. Mohon isi ulang terlebih dahulu!',
  Theservicecardpasswordenteredisinthewrongformat: 'Format kata sandi kartu layanan yang dimasukkan salah.',
  Pleaseselectaregion: 'Silakan pilih wilayah',
  Changeemailaddress: 'Ubah alamat email',
  Editdetailedaddress: 'Edit alamat detail',
  Bindingplatformisenabled: 'Pengikatan platform telah diaktifkan.',
  Bindingplatformhasbeenclosed: 'Pengikatan platform telah ditutup.',
  Memberdisplayturnedon: 'Tampilan anggota diaktifkan.',
  Memberdisplayturnedoff: 'Tampilan anggota telah dimatikan.',
  Noisecancellationturnedon: 'Peredam kebisingan diaktifkan.',
  Noisecancellationturnedoff: 'Peredam kebisingan dimatikan.',
  deleteOrg: 'Apakah Anda sudah yakin menghapus pesan unit ini?',
  successfullydeleted: 'Berhasil dihapus',
  successfullyset: 'Pengaturan berhasil',
  Thisgroupisalreadythedefaultgroup: 'Grup ini sudah menjadi grup default!',
  deletedUserGroup: 'Apakah Anda sudah yakin menghapus pengguna dari grup?',
  deletedGroup: 'Apakah Anda sudah yakin menghapus grup ini?',
  Youhavenotmodifiedthenoteinformation: 'Anda belum mengubah informasi keterangan.',
  Areyousureyouwanttoremovethismember: 'Apakah Anda sudah yakin menghapus anggota ini?',
  Pleaseselectamembertoadd: 'Silakan pilih anggota yang ingin Anda tambahkan.',
  Memberaddedsuccessfully: 'Anggota berhasil ditambahkan.',
  Theservicecardpasswordentered: 'Format kata sandi kartu layanan yang dimasukkan salah.',
  Thepasswordsenteredtwiceareinconsistent: 'Kedua kata sandi tidak sama, silakan diulang kembali',
  successfullyopened: 'Aktivasi berhasil!',
  Modifycontactnumber: 'Ubah nomor kontak',
  Changeemailaddress: 'Ubah alamat email',
  Modifymailingaddress: 'Ubah alamat komunikasi',
  changeusername: 'Ubah nama panggilan',
  Outofwarrantyandcannotbereplaced: 'Garansi sudah habis dan tidak dapat diganti.',
  Recycledsuccessfully: 'Pemulihan berhasil',
  restarttheterminaltotakeeffect: 'Perubahan akan berlaku setelah terminal dihidupkan ulang!',
  UserTalkbackSuspended: 'Fungsi interkom pengguna telah ditangguhkan.',
  Theuserintercomfunctionisturnedon: 'Fungsi interkom pengguna telah diaktifkan.',
  shakeoff: 'Goncang untuk on',
  Shaketodeath: 'Goncang untuk off',
  Unitdispatcherison: 'Unit dispatcher on',
  Unitdispatcherisclosed: 'Unit dispatcher off',
  Changeuseraffiliation: "Apakah Anda yakin ingin mengubah posisi pengguna?",
  Pleaseselectauser: 'Silakan pilih pengguna',
  PleaseentertheoldIMEIcorrectly: 'Silakan masukkan nomor IMEI lama 15 digit yang benar.',
  PleaseenterthenewIMEIcorrectly: 'Silakan masukkan nomor IMEI 15 digit baru Anda dengan benar.',
  Replacedthecardsuccessfully: 'Penggantian kartu berhasil.',
  TheoriginalIMEIentereddoesnotexist: 'IMEI semula yang dimasukkan tidak ada.',
  TheenterednewIMEIisalreadyinuse: 'IMEI baru tersebut sudah digunakan.',
  Cardreplacementfailed: 'Penggantian kartu gagal',
  Theverificationcodehasexpiredpleasegetitagain: 'Kode verifikasi telah kedaluwarsa. Silakan dapatkan kode verifikasi baru!',
  Pleaseentercorrectverifycode: 'Silakan masukkan kode verifikasi yang benar!',
  Verificationcodeerror: 'Kode verifikasi error!',
  Pleaseenteramobilephonenumberinthecorrectformat: 'Silakan masukkan nomor ponsel Anda dalam format yang benar.',
  Pleaseselectthelisteninggrouptobeadded: 'Silakan pilih kelompok pendengar yang ingin Anda tambahkan.',
  Confirmtoaddlisteninggroup: 'Konfirmasi penambahan grup pendengar?',
  Addedsuccessfully: 'Berhasil ditambahkan',
  adding: 'Menambahkan...',
  deleting: 'Menghapus...',
  Areyousuretodeletethislisteninggroup: 'Apakah Anda ingin mengkonfirmasi penghapusan grup pendengar ini?',
  GPSison: 'GPS kini telah diaktifkan dan perangkat telah dihidupkan ulang agar perubahan dapat diterapkan!',
  GPSisoff: 'GPS telah dinonaktifkan dan perangkat telah dihidupkan ulang agar perubahan berlaku!',
  Doyouwanttocontinue: 'Apakah Anda ingin melanjutkan dengan pengguna yang kartu lokasinya belum kedaluwarsa?',
  Renewalsuccessful: 'Perpanjangan berhasil!',
  IMEIdoesnotexist: 'IMEI tidak ada',
  Insufficientservicecardbalance: 'Saldo kartu layanan tidak mencukupi',
  andtheterminalneedstoberestarted: 'Setelah berhasil mengganti unit terkait, terminal perlu dihidupkan ulang.',
  Modifytheaffiliatedunitsuccessfully: 'Unit afiliasi berhasil diubah.',
  rOrg_tips: 'Nama organisasi harus memiliki panjang 4-20 karakter, angka, huruf, dan garis bawah. tidak boleh diawali dengan garis bawah.',
  rNamep_tips: 'Panjangnya harus 2-10 karakter, terdiri dari angka, huruf, dan garis bawah. Nama file tidak boleh diawali dengan garis bawah.',
  rNamep_tips20: 'Panjangnya harus antara 2 hingga 20 karakter angka, huruf, dan garis bawah. Nama file tidak boleh diawali dengan garis bawah.',
  rPhone_tips: 'Format nomor telepon seluler salah',
  rAgent_tips: 'Nama agen harus terdiri dari 4-20 angka, huruf, dan garis bawah, serta tidak boleh diawali dengan garis bawah.',
  wAgent_tips: 'Nama tersebut terdiri dari 1-15 angka, huruf, dan garis bawah, dan tidak boleh diawali dengan garis bawah.',
  rGroup_tips: 'Nama grup sebaiknya terdiri dari 2-15 karakter.',
  rGroup2_tips: 'Nama grup terdiri dari 2-12 digit dan abjad.',
  rAccount_tips: 'Nama akun harus terdiri dari 6-20 abjad, angka, dan garis bawah.',
  rPwd_tips: 'Kata sandi sebaiknya terdiri dari 6-16 karakter dan berisi huruf dan angka.',
  rName_tips: 'Panjangnya harus 2-7 karakter, terdiri dari  angka, huruf, dan garis bawah. Nama file tidak boleh diawali dengan garis bawah.',
  rNamep1_tips: 'Nama panggilan pengguna terdiri dari 2-30 karakter.',
  rEmail_tips: 'Silakan masukkan alamat email Anda dalam format yang benar.',
  rInt_tips: 'Silakan masukkan bilangan bulat positif.',
  rInputNum_tips: 'Silakan masukkan angka.',
  rBroad_tips: 'Input harus terdiri dari angka, dan huruf.',
  rVerifyCode_tips: 'Kode verifikasi seluler adalah angka 4 digit.',
  rICCID_tips: 'ICCID harus terdiri dari 19 atau 20 karakter alfanumerik.',
  rIMEI_tips: 'IMEI harus terdiri dari 15 digit.',
  removegroupleader: 'Apakah menghapus pemilik grup secara otomatis menghapus grup yang dibuat sendiri ini?',
  removeselfcreatedgroups: 'Apakah Anda ingin mengkonfirmasi penghapusan grup yang Anda buat sendiri dan penghapusan otomatisnya?',
  removeselfcreatedgroupsTow: 'Apakah Anda yakin ingin mengubah organisasi pengguna dan menghapus secara otomatis grup yang dibuat sendiri oleh pengguna?',
  PleaseselectSOS: 'Silakan pilih pengguna yang layanan SOS-nya belum diaktifkan.',
  Pleaseselectuserswhohavenotenabledtheservice: "Silakan pilih pengguna yang belum mengaktifkan layanan.",
  Logintimedout: 'Login gagal!',
  Serverconnectionexception: 'Kesalahan koneksi server',
  ServerconnectionexceptionLoaing: 'memuat',
  Nolocationtrack: 'Tidak ada pelacakan lokasi',
  Areyousuretodeletethemember: 'Konfirmasi penghapusan anggota ini?',
  update_successfully: 'Pembaruan berhasil',
  updatecompleted: 'Pembaruan berhasil',
  Pleaseselecttheexportdaterange: 'Silakan pilih rentang tanggal ekspor untuk 90 hari terakhir.',
  Thestarttimecannotbegreaterthantheendtime: 'Waktu mulai tidak boleh lebih besar dari atau sama dengan waktu berakhir.',
  Theendtimecannotbelessthanthestarttime: 'Waktu berakhir tidak boleh kurang dari atau sama dengan waktu mulai.',
  Areyousureyouwanttodeletethisfence: 'Apakah Anda ingin mengkonfirmasi penghapusan pagar ini?',
  Thefencenameisduplicated: 'Harap ubah nama pagar jika ada yang sama dan coba lagi.',
  setptttips: 'Silakan pilih periode layanan',
  Pleaseselectareareplacement: 'Silakan pilih area yang ingin diubah.',
  Successfuloperation: 'Operasi berhasil',
  Areyousuretoresettheuserpassword: 'Apakah Anda yakin ingin memulihkan kata sandi pengguna ini?',
  selectedvipcardTpis: 'Perekaman isi ulang, pelacakan lokasi, SOS, dan layanan geofencing untuk pengguna kartu VIP terpilih akan difilter secara otomatis.',
  selectedpttgpscardTpis: 'Pengguna terpilih yang mengisi ulang kartu layanan lokasi menggunakan layanan suara + lokasi akan difilter secara otomatis.',
  closeAgentTips: 'Setelah ditutup, layanan tidak akan ditampilkan kepada pengguna agen tingkat bawah. Pengguna dalam periode layanan dapat terus menggunakan layanan tersebut. Apakah Anda yakin ingin menutupnya?',
  vipCardNoTips: 'Fungsi perekaman, lokasi, SOS, dan geofence bagi pengguna kartu VIP bersifat permanen dan tidak memerlukan aktivasi.',
  pttCardNoTips: 'Kartu layanan belum perlu diaktifkan.',
  pointtips1: 'Fungsi panggilan individual untuk setiap pengguna telah diaktifkan.',
  pointtips2: 'Fungsi panggilan satu kali pengguna telah dinonaktifkan.',
  LimitspecifiedEnglish: 'pilih, perbarui, dan, atau, hapus, sisipkan, transkrip, char, chr, ke dalam, substr, ascii, deklarasikan, jalankan, hitung, master, jatuhkan, eksekusi, skrip, bidang iframe',
  Thecommentcontentcannotcontain: 'Komentar tersebut tidak boleh mengandung',
  Theagentsremarkscannotcontain: "Pernyataan agen tersebut tidak dapat mencakup",
  theagencynamecannotcontain: 'Nama agen tidak boleh mengandung',
  Thecompanynamecannotcontain: 'Nama perusahaan tidak boleh mengandung',
  Thegroupnamecannotcontain: 'Nama grup tidak boleh mengandung',
  Usernamecannotcontain: 'Nama pengguna tidak boleh mengandung',
  Registeredsuccessfully:'Pendaftaran berhasil',
  UnbindingUserTips:'Setelah melepaskan ikatan, semua data pengguna dari semua grup kerja akan dihapus. Terminal tidak akan dapat masuk. Apakah Anda yakin ingin melepaskan ikatan?',
  Failedtocreategrouppleasebinddevicefirst:'Jika pembuatan grup gagal, harap tautkan perangkat Anda terlebih dahulu.',
  Devicebindingsuccessful:'Pemasangan perangkat berhasil.',
  Devicebindingfaileddifferentownership:'Kegagalan pengikatan perangkat karena atribusi yang berbeda.',
  Devicebindingfailedaccountdoesnotexist:'Pengikatan perangkat gagal, akun tidak ditemukan.',
  Devicebindingfailedalreadybound:'Pengikatan perangkat gagal (sudah terikat)',
  Devicebindingfailedalreadyexists:'Kegagalan pengikatan perangkat sudah terjadi.',
  The_maximum_duration_can_only_be_set_to_60_minutes:'Durasi maksimum hanya dapat diatur hingga 60 menit.',
  SOS_transmission_interval:'Interval transmisi SOS',
  Please_set_the_SOS_interval:'Harap atur interval SOS.',
  recyclingServiceCardTips:'Setelah daur ulang dikonfirmasi, pengguna akan dihapus dan kartu layanan yang telah digunakan akan didaur ulang.',
  Pleasebindthedevicefirst:'Harap hubungkan perangkat Anda terlebih dahulu.',
  agent_name_existed: 'Nama agen tersebut sudah ada.',
  company_existed: 'Nama perusahaan tersebut sudah ada.',
}
